import React from 'react';
import PropTypes from 'prop-types';
import {needAdsRefresh} from '../../utils/need-ads-refresh';
import {onAdsContextInit, onDestinationChange, onPageUpdate} from '../../services/targeting';

export const Context = React.createContext(null);

export class MesoAdsContext extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            allowAds: false,
            isBrowser: typeof window !== 'undefined'
        };

        /* istanbul ignore next */
        if (this.state.isBrowser) {
            const isAdblock = (window.adblock || typeof window.adblock === 'undefined');
            this.state.allowAds = !isAdblock;
            this.state.prevSearch = window.location.search;
        }
    }

    componentDidMount() {
        /* istanbul ignore next */
        if (this.state.isBrowser) {
            const {brandId, locale, havId, gaiaId} = this.props;
            onAdsContextInit({brandId, locale, havId, gaiaId});
        }
    }

    componentDidUpdate(prevProps) {
        const {pathname: prevPathname} = prevProps.searchParams;
        const {params, prevParams, pathname} = this.props.searchParams;

        if (this.state.isBrowser) {
            if (pathname !== prevPathname) {
                needAdsRefresh(params, prevParams) && onPageUpdate();
            }

            if (window.location.search !== this.state.prevSearch) {
                onPageUpdate();
                this.setState({ prevSearch: window.location.search });
            }

            if (prevProps.gaiaId !== this.props.gaiaId) {
                onDestinationChange(this.props.gaiaId);
            }
        }
    }

    render() {
        return (
            <Context.Provider value={this.state}>
                {this.props.children}
            </Context.Provider>
        );
    }
}

MesoAdsContext.propTypes = {
    brandId: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
    havId: PropTypes.string.isRequired,
    gaiaId: PropTypes.string
};
